<div
  class="wrapper w-[755px] mb-[20px] cursor-pointer"
  >
  <div class="header-section flex gap-[12px] w-full">
    <div class="left w-[48px]">
      <div class="icon-holder flex justify-center items-center">
        <mat-icon [svgIcon]="icon" class="icon" />
      </div>
    </div>
    <div class="right w-10/12">
      <div [innerHTML]="titleHtml" class="heading text-type-6 w-full">
      </div>
      <div class="subheading flex gap-[12px] text-type-14 w-full">
        @if (meta) {
          <div class="meta">
            {{ meta }}
          </div>
        }
        @if (result?.updated_at) {
          <div class="last-updated-at">
            {{ result?.updated_at | dateFormat: 'ago-tiny' }} ago
          </div>
        }
      </div>
    </div>
  </div>
  @if (snippet) {
    <div [innerHTML]="snippetHtml" class="content text-type-10">
    </div>
  }
  @if (matchedHintHtml) {
    <div [innerHTML]="matchedHintHtml" class="matched-hint text-type-14">
    </div>
  }
  @if (status) {
    <div class="status-section flex gap-[20px]">
      <div class="status text-type-12">
        {{ status }}
      </div>
    </div>
  }
</div>
